export enum Declaracoes {
  matricula = 1,
  conclusao = 2
}
